import { createRouter, createWebHashHistory } from 'vue-router';
import FormView from '../views/FormView.vue';
import CareerView from '../views/CareerView.vue';
import PhotoView from '../views/PhotoView.vue';
import OneYearView from '../views/OneYearView.vue';
import WinView from '../views/WinView.vue';
import LoseView from '../views/LoseView.vue';
import { useGameStore } from '../stores/game';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'form',
      component: FormView
    },
    {
      path: '/career/:playerId',
      name: 'data',
      component: CareerView
    },
    {
      path: '/photo/:playerId',
      name: 'photo',
      component: PhotoView
    },
    {
      path: '/one-year/:playerId/:season',
      name: 'one-year',
      component: OneYearView
    },
    {
      path: '/win',
      name: 'win',
      component: WinView,
      meta: { requiresGame: true }
    },
    {
      path: '/lose',
      name: 'lose',
      component: LoseView,
      meta: { requiresGame: true }
    }
  ]
});

router.beforeEach((to) => {
  if (!to.meta.requiresGame) return true;

  const store = useGameStore();
  if (!store.hasGame) {
    return { name: 'form' };
  }

  return true;
});

export default router;
